export const PublicPath = process.env.NEXT_PUBLIC_BASE_PATH || '';
export const ContentPath = 'https://special.pikabu.ru/gazprom-one-day-api/uploads/';

export const IsCompleted = false;

export enum SocialId {
    Ok = 'ok',
    Fb = 'fb',
    Tw = 'tw',
    Vk = 'vk',
    Tg = 'tg',
}

export interface StringMap {
    [key: string]: any;
}
